/*
Provides small contained functions that can be executed on a subscription
Anything from delete to refreshing
*/

import toast from "react-hot-toast";
import { openConfirmModal } from "../../../components/modals/ConfirmModal";
import { useDeleteSubscriptionMutation, useRefreshSubscriptionMutation } from "../../../services/graph";
import { GraphSubscriptionType } from "../../../types/GraphSubscriptionType";

export type SubscriptionControlProps = {
    deleteSubscription: () => void
    refreshSubscription: () => void
};

export const useSubscriptionControls = (subscription: GraphSubscriptionType) : SubscriptionControlProps => {
    const [deleteFn] = useDeleteSubscriptionMutation();
    const [refreshFn] = useRefreshSubscriptionMutation();

    const deleteSubscription = () : void => {
        openConfirmModal({
            dialogTitle: "Delete Subscription?",
            message: "Removing a subscription will prevent notifications about changes outwith WealthPro to a users Mailbox, Calendar, etc from syncing with our internal WealthPro records. Are you sure you want to delete this subscription?",
            confirmButtonText: "Delete Subscription",
            confirmButtonVariant: 'danger'
        }).then(
            (r: boolean) => {
                if (!r) {
                    return;
                }
                toast.promise(deleteFn(subscription.id).unwrap(), {
                    loading: 'Removing subscription from 365...',
                    success: 'Subscription was successfully removed.',
                    error: 'Failed to remove the subscription.'
                }).then(() => {});
            },
            () => {}
        )
    };

    const refreshSubscription = () : void => {
        toast.promise(refreshFn(subscription.id), {
            loading: 'Refreshing the expiration of the 365 subscription...',
            success: 'Subscription was successfully refreshed with new expiration date.',
            error: 'Failed to refresh the subscription.'
        }).then(() => {});
    }

    return {
        deleteSubscription,
        refreshSubscription
    };
};